import { Injectable } from '@angular/core';
import { includes, remove } from 'lodash-es';

/**
 * Native port of the v1 `ftTasks` factory (account-v1/.../tasks/tasks.service.js)
 * — the pending-task registry behind the v1 `*-while-task-pending` /
 * `ft-start-task` / `ft-finish-task` directive family. WS5 #10 Stage A inc 2u.
 *
 * ⚠ SHARED-INSTANCE CONTRACT: the registry is cross-framework state — v1
 * spinners/disablers watch the SAME instance native components register tasks
 * on. The v1 factory is DELETED and this service is downgradeInjectable'd back
 * into AngularJS as 'ftTasks' (bootstrap-angularjs.config.ts — the curationModal
 * recipe), so both worlds keep exactly one registry.
 *
 * Verbatim semantics incl. the lodash calls (`remove` clears EVERY matching
 * entry; `register` dedupes via isPending).
 */
@Injectable({ providedIn: 'root' })
export class FtTasksService {
  pendingTasks: string[] = [];

  /** v1 `Tasks.register(name)` — no-op if already pending. */
  register(name: string): void {
    if (!this.isPending(name)) {
      this.pendingTasks.push(name);
    }
  }

  /** v1 `Tasks.finish(name)`. */
  finish(name: string): void {
    remove(this.pendingTasks, (task: string) => task === name);
  }

  /** v1 `Tasks.isPending(name)`. */
  isPending(name: string): boolean {
    return includes(this.pendingTasks, name);
  }
}
